import React from 'react';
import './Experience.css';

function Experience() {
  const partners = [
    { name: 'UEFA Euro 2020', logo: '23-237350_uefa-euro-2020-logo-euro-2020-logo-png.svg' },
    { name: 'Barclays', logo: 'barclays.webp' },
    { name: 'FIFA World Cup 2018', logo: '2018_FIFA_World_Cup.svg.webp' },
    { name: 'DAZN', logo: 'dazn-logo-png_seeklogo-399335.webp' },
    { name: 'Hungarian Olympic Committee', logo: 'Hungarian_Olympic_Committee_logo.webp' },
    { name: 'Glencore', logo: 'Glencore.png' },
    { name: 'FINA Budapest', logo: 'fina-budapest-logo.png' },
    { name: 'Rugby World Cup 2023', logo: 'Rugby_World_Cup_2023_logo.webp' },
    { name: 'NEOM', logo: 'neom5478.png' },
    { name: 'FIFA World Cup 2014', logo: '2014_FIFA_World_Cup.webp' },
    { name: 'Santander', logo: 'santanderlogo.png' },
    { name: 'World Athletics Championships 2022', logo: '2022_World_Athletics_Championships_logo_2.webp' },
    { name: 'World Athletics Championships 2023', logo: '2023_World_Athletics_Championships_logo.webp' },
    { name: 'Stats Perform', logo: 'Stats-Perform-Logo.webp' }
  ];

  // Duplicate partners for seamless infinite scroll
  const duplicatedPartners = [...partners, ...partners];

  return (
    <div className="experience">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">Our Experience</span>
          <h2 className="section-title">Trusted by Leading Brands & Organizations</h2>
        </div>
      </div>
      
      <div className="partners-carousel">
          <div className="carousel-wrapper">
            <div className="carousel-track">
              {duplicatedPartners.map((partner, index) => (
                <div 
                  key={`carousel-${index}`} 
                  className="partner-item"
                >
                  <img 
                    src={`/img/partners/${partner.logo}`} 
                    alt={partner.name}
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.parentElement.innerHTML = `<span>${partner.name}</span>`;
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>

      <div className="container">
        <div className="experience-values">
          <div className="value-item">
            <h3>Precision.</h3>
          </div>
          <div className="value-item">
            <h3>Expertise.</h3>
          </div>
          <div className="value-item">
            <h3>Trust.</h3>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Experience;
